import { Helmet, HelmetData } from 'react-helmet-async';

import { PRODUCT_APP_NAME } from '@/config';

type HeadProps = {
  title?: string;
  description?: string;
};

const helmetData = new HelmetData({});

export const Head = ({ title = '', description = '' }: HeadProps = {}) => {
  return (
    <Helmet
      helmetData={helmetData}
      title={title ? `${title} | ${PRODUCT_APP_NAME}` : undefined}
      defaultTitle="TaksoAI WebApp"
    >
      <meta name="description" content={description} />
    </Helmet>
  );
};
